import * as deployments from '@wix/auto_sdk_editor-deployments_deployments';

export { deployments };
